const ResponseCode = {
    SUCCESS : 0,
    FAIL : -1,
    LOGIN_INVALID : -30,
    VERSION_CHANGED : -9000,
}

 export default ResponseCode;